import {CushlaGetQueryOptions, endpointKeys} from '@common/api'
import {EndOfDayData, SetEndOfDayRequest} from '@common/models'
import {endOfDayListNormaliser} from '@common/normalisers/endOfDay'

import {useApi, useWebGet, useWebSet} from './helpers'

export const useGetEndOfDayData = (
  facilityId: string,
  options?: CushlaGetQueryOptions<EndOfDayData[]>,
) =>
  useWebGet<EndOfDayData[]>(
    [endpointKeys.practitionerEndOfDay, facilityId],
    useApi().practitionerEndOfDay({facilityId}),
    endOfDayListNormaliser,
    {
      staleTime: 0,
      gcTime: 0,
      refetchOnMount: 'always',
      refetchOnWindowFocus: true,
      ...options,
    },
  )

export const useSubmitEndOfDayReport = (facilityId: string) => {
  const api = useApi()

  return useWebSet<SetEndOfDayRequest, void>(
    [endpointKeys.endOfDay, facilityId],
    api.endOfDay({facilityId}),
    'POST',
    () => undefined,
    [[endpointKeys.practitionerEndOfDay]],
  )
}
